var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFactoryPush(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 5,
    fill: "url(#paint0_linear_224_729)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.33 26.0714C20.0336 26.0714 18.9728 25.0186 18.9728 23.7143C18.9728 23.62 18.9886 23.5335 19.0043 23.4393H18.5564C17.26 23.4393 16.1993 22.3864 16.1993 21.0821C16.1993 20.3985 16.5057 19.7778 16.9771 19.3536V16.7607C16.9771 14.3957 18.4543 12.3686 20.5364 11.5514C20.945 10.8443 21.6993 10.3571 22.5793 10.3571C23.1764 10.3571 23.7264 10.585 24.135 10.97C24.0721 9.31999 22.705 8 21.0393 8H13.1036C11.3907 8 10 9.39068 10 11.1036V26.8964C10 28.6093 11.3907 30 13.1036 30H21.0393C22.7521 30 24.1429 28.6093 24.1429 26.8964V26.04C24.0328 26.0636 23.9228 26.0714 23.805 26.0714H21.33ZM17.0636 11.1429H17.0714C17.5036 11.1429 17.8571 11.4964 17.8571 11.9286C17.8571 12.3607 17.5036 12.7143 17.0714 12.7143C16.6314 12.7143 16.2778 12.3607 16.2778 11.9286C16.2778 11.4964 16.6236 11.1429 17.0636 11.1429Z",
    fill: "url(#paint1_linear_224_729)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6022 20.3V16.7607C26.6022 14.8121 25.2115 13.1857 23.3651 12.8164L23.3614 12.8159V12.7143C23.3614 12.28 23.0099 11.9286 22.5756 11.9286C22.1414 11.9286 21.7899 12.28 21.7899 12.7143V12.8096C19.9454 13.1726 18.5486 14.8135 18.5486 16.7607V20.2999C18.1201 20.3065 17.7747 20.6531 17.7747 21.0832C17.7747 21.5175 18.1261 21.8689 18.5604 21.8689H26.5902C27.0244 21.8689 27.3759 21.5175 27.3759 21.0832C27.3759 20.6532 27.0305 20.3068 26.6022 20.3Z",
    fill: "url(#paint2_linear_224_729)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8056 22.9286H21.3319C20.8976 22.9286 20.5461 23.28 20.5461 23.7143C20.5461 24.1486 20.8976 24.5 21.3319 24.5H23.8056C24.2399 24.5 24.5913 24.1486 24.5913 23.7143C24.5913 23.28 24.2399 22.9286 23.8056 22.9286Z",
    fill: "url(#paint3_linear_224_729)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_224_729",
    x1: 0,
    y1: 0,
    x2: 37,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F80ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CCF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_224_729",
    x1: 23.1401,
    y1: 11.9728,
    x2: 7.37652,
    y2: 12.3032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_224_729",
    x1: 26.6952,
    y1: 13.7236,
    x2: 15.9995,
    y2: 14.0604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_224_729",
    x1: 24.3045,
    y1: 23.2124,
    x2: 19.8253,
    y2: 23.5883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactoryPush);
export default __webpack_public_path__ + "static/media/factory-push.b210f154ad24be1407c3abc607232a04.svg";
export { ForwardRef as ReactComponent };